import { useObservableEagerState } from "observable-hooks";
import useConstant from "use-constant";
import { observeIsInitialSyncComplete } from "~/observables/observeIsInitialSyncComplete";

export function useIsInitialSyncComplete() {
  const observable = useConstant(observeIsInitialSyncComplete);
  return useObservableEagerState(observable);
}
